export class UnsupportedOperationException extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'UnsupportedOperationException';
    Object.setPrototypeOf(this, UnsupportedOperationException.prototype);
  }
}
